import { useState } from 'react';
import { useGame } from '../state/SocketProvider';

/**
 * v8 (BOLT-013) — host-only lobby control to import a community Pack (paste JSON
 * or fetch a URL, incl. a raw GitHub file). The server sanitizes + validates it
 * (script cards run the trust gate) before applying, so loading one is trustless.
 */
export function ImportPack(): JSX.Element {
  const { send } = useGame();
  const [text, setText] = useState('');
  const [url, setUrl] = useState('');
  const [msg, setMsg] = useState('');

  const importPack = (raw: string) => {
    try {
      send({ t: 'import_pack', pack: JSON.parse(raw) });
      setMsg('Imported. Community cards are added to the seeker deck.');
    } catch {
      setMsg('That is not valid Pack JSON.');
    }
  };

  const fetchUrl = async () => {
    try {
      const res = await fetch(url.trim());
      importPack(await res.text());
    } catch {
      setMsg('Could not fetch that URL.');
    }
  };

  return (
    <section className="import-pack" data-testid="import-pack">
      <h3 className="eyebrow">Import community pack</h3>
      <textarea
        className="import-pack__input studio__editor"
        data-testid="import-pack-input"
        placeholder="Paste a Pack JSON…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={4}
      />
      <div className="import-pack__row">
        <button className="btn" data-testid="import-pack-btn" disabled={!text.trim()} onClick={() => importPack(text)}>
          Import pasted
        </button>
      </div>
      <div className="import-pack__row">
        <input
          className="import-pack__url"
          data-testid="import-pack-url"
          placeholder="…or a Pack URL (raw GitHub)"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button className="btn btn--ghost" data-testid="import-pack-url-btn" disabled={!url.trim()} onClick={fetchUrl}>
          Fetch
        </button>
      </div>
      {msg && <p className="import-pack__msg" data-testid="import-pack-msg">{msg}</p>}
    </section>
  );
}
